import { render, staticRenderFns } from "./qa-list.vue?vue&type=template&id=244a604e&scoped=true&"
import script from "./qa-list.vue?vue&type=script&lang=ts&"
export * from "./qa-list.vue?vue&type=script&lang=ts&"
import style0 from "./qa-list.vue?vue&type=style&index=0&id=244a604e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a604e",
  null
  
)

export default component.exports